const AnomalyScoreRanges = () => {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <div className="mb-5 text-lg font-semibold text-gray-900">Anomaly score ranges</div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div className="flex items-start gap-3 rounded-lg border-l-4 border-red-500 bg-red-50 p-4">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <div className="text-base font-semibold text-red-900">P0: 10</div>
            <div className="text-sm text-red-800">
              Urgent - Send notification immediately. Extremely prominent on our site.
            </div>
          </div>
        </div>
        <div className="flex items-start gap-3 rounded-lg border-l-4 border-yellow-500 bg-yellow-50 p-4">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <div className="text-base font-semibold text-yellow-900">P1: ≥9</div>
            <div className="text-sm text-yellow-800">
              High priority - Send notification soon. Very prominent on our site.
            </div>
          </div>
        </div>
        <div className="flex items-start gap-3 rounded-lg border-l-4 border-blue-500 bg-blue-50 p-4">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <div className="text-base font-semibold text-blue-900">P2: ≥8</div>
            <div className="text-sm text-blue-800">
              Medium priority - Possible weekly summary notification. Prominent on our site
            </div>
          </div>
        </div>
        <div className="flex items-start gap-3 rounded-lg border-l-4 border-green-500 bg-green-50 p-4">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <div className="text-base font-semibold text-green-900">P3: ≥6</div>
            <div className="text-sm text-green-800">
              Low priority - No notification. Shown on our site deep in the site as FYI.
            </div>
          </div>
        </div>
        <div className="flex items-start gap-3 rounded-lg border-l-4 border-gray-400 bg-gray-50 p-4">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <div className="text-base font-semibold text-gray-700">P4: &lt;6</div>
            <div className="text-sm text-gray-600">Not an anomaly.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnomalyScoreRanges;
